import { Day } from "./types";

// --- Constants ---

export const DAYS: Day[] = [
  { key: "mon", label: "Lun", fullLabel: "Lunes", isWeekday: true, isWeekend: false },
  { key: "tue", label: "Mar", fullLabel: "Martes", isWeekday: true, isWeekend: false },
  { key: "wed", label: "Mié", fullLabel: "Miércoles", isWeekday: true, isWeekend: false },
  { key: "thu", label: "Jue", fullLabel: "Jueves", isWeekday: true, isWeekend: false },
  { key: "fri", label: "Vie", fullLabel: "Viernes", isWeekday: true, isWeekend: false },
  { key: "sat", label: "Sáb", fullLabel: "Sábado", isWeekday: false, isWeekend: true },
  { key: "sun", label: "Dom", fullLabel: "Domingo", isWeekday: false, isWeekend: true },
];

export const SLOT_HEIGHT = 20;
export const TIME_COLUMN_WIDTH = 52;
export const TOTAL_SLOTS = 48;
export const DEFAULT_SCROLL_SLOT = 15;

function generateTimeSlots(): string[] {
  const slots: string[] = [];
  for (let h = 0; h < 24; h++) {
    const hh = String(h).padStart(2, "0");
    slots.push(`${hh}:00`);
    slots.push(`${hh}:30`);
  }
  return slots;
}

export const TIME_SLOTS = generateTimeSlots();

// --- Night constants ---

export const NIGHT_EVENING_START = 42; // 21:00
export const NIGHT_MORNING_END = 18; // 09:00
export const WEEKDAY_NIGHT_STARTS = ["mon", "tue", "wed", "thu", "fri"];
export const WEEKEND_NIGHT_STARTS = ["sat", "sun"];

// --- Mobile select options ---

export const HOUR_OPTIONS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
export const END_HOUR_OPTIONS = [...HOUR_OPTIONS, "24"];
export const MINUTE_OPTIONS = ["00", "30"];
